import React from "react";
import { ArrowLeft, FileText } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import useFormOverview from "../../../hooks/useFormOverview";

export default function EmployeeFormOverview() {
  const navigate = useNavigate();
  const { formCode } = useParams();
  const { overview, loading, error } = useFormOverview(formCode);

  console.log("EmployeeFormOverview - formCode:", formCode);
  console.log("EmployeeFormOverview - overview:", overview);
  console.log("EmployeeFormOverview - loading:", loading);
  console.log("EmployeeFormOverview - error:", error);

  const handleStartForm = () => {
    navigate(`/employee/forms/fill/${formCode}`);
  };

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="flex items-center justify-center py-12">
          <div className="text-gray-500">Loading form overview...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="flex items-center justify-center py-12">
          <div className="text-red-500">{error}</div>
        </div>
      </div>
    );
  }

  if (!overview) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="flex items-center justify-center py-12">
          <div className="text-gray-500">Form not found</div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition"
      >
        <ArrowLeft className="h-5 w-5" />
        <span>Back to My Forms</span>
      </button>

      {/* Form Header */}
      <div className="bg-white border border-gray-200 rounded-xl p-8 mb-6">
        <div className="flex items-start gap-4">
          <div className="h-16 w-16 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <FileText className="h-8 w-8 text-blue-600" />
          </div>
          <div className="flex-1">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {overview.title}
            </h1>
            <p className="text-gray-600 text-lg">{overview.description}</p>
          </div>
        </div>
      </div>

      {/* Purpose */}
      {overview.purpose && (
        <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Purpose</h2>
          <p className="text-gray-600">{overview.purpose}</p>
        </div>
      )}

      {/* Instructions */}
      {overview.instructions && overview.instructions.length > 0 && (
        <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Instructions</h2>
          <ul className="space-y-3">
            {overview.instructions.map((instruction, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-medium">
                  {index + 1}
                </span>
                <span className="text-gray-600 pt-0.5">{instruction}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Start Filling Form Button */}
      <div className="flex justify-end">
        <button
          onClick={handleStartForm}
          className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition"
        >
          Start Filling Form
        </button>
      </div>
    </div>
  );
}
